export interface ErrorRecoveryAction {
  label: string;
  path: string;
  errorMessage: string;
}

export const createErrorRecoveryAction = (
  errorMessage: string,
  action: Pick<ErrorRecoveryAction, 'label' | 'path'>,
): ErrorRecoveryAction => ({
  ...action,
  errorMessage,
});

export const getVisibleErrorRecoveryAction = (
  currentError: string | null | undefined,
  action: ErrorRecoveryAction | null,
): ErrorRecoveryAction | null => (
  action && currentError === action.errorMessage ? action : null
);
